import {
  InventoryItem,
} from '../../model/inventory';

export class InventoryApiMapper {
  static toDeleteDetails(api: any): {
    deletedCount: number;
    deletedIds: InventoryItem['id'][];
  } {
    return {
      deletedCount: api.deletedCount,
      deletedIds: api.deletedIds,
    };
  }
}
